// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/bars-3.svg. Do not edit.

import type { Glyph } from '../../types'

export const glyph: Glyph = {
  name: 'bars-3',
  version: 'outline',
  paths: [
    {
      d: 'M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5',
    },
  ],
}
